import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Proptypes from 'prop-types';
import * as Yup from 'yup';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';

import { FormProvider, RHFTextField } from '../hook-form';
import { api as stockApi } from '../../store/domains/stock';

NumberDiscoveryRangeDialog.propTypes = {
  open: Proptypes.bool,
  handleClose: Proptypes.func,
  posManagerOrganizations: Proptypes.object,
};

export default function NumberDiscoveryRangeDialog({ open, handleClose, posManagerOrganizations }) {
  const [postNumberDiscoveryWithRangeMutation, { isLoading }] = stockApi.usePostNumberDiscoveryithRange();

  const RangeSchema = Yup.object().shape({
    minId: Yup.string().required('Min range is required'),
    maxId: Yup.string().required('Max range is required'),
    partnerId: Yup.string().required('Partner is required'),
  });

  const defaultValues = {
    minId: '',
    maxId: '',
    partnerId: '',
  };

  const methods = useForm({
    resolver: yupResolver(RangeSchema),
    defaultValues,
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = (data) => {
    postNumberDiscoveryWithRangeMutation(data)
      .unwrap()
      .finally(() => {
        reset();
        handleClose();
      });
  };
  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Select range</DialogTitle>
      <DialogContent>
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3} sx={{ my: 2 }}>
            <RHFTextField name="minId" label="Min range" />
          </Stack>{' '}
          <Stack spacing={3} sx={{ my: 2 }}>
            <RHFTextField name="maxId" label="Max range" />
          </Stack>
          <FormControl fullWidth>
            <InputLabel>Partner</InputLabel>
            <Controller
              control={methods.control}
              name="partnerId"
              defaultValue=""
              render={({ field }) => (
                <Select label="Partnert" {...field}>
                  {posManagerOrganizations?.map(({ id, title }) => (
                    <MenuItem key={id} value={id}>
                      {title}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            <LoadingButton
              sx={{ my: 2 }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={isLoading}
              disabled={isLoading}
            >
              Submit
            </LoadingButton>
          </FormControl>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
}
